module.exports = __webpack_public_path__ + "img/img-default.ac183e83.png";